import React, {useEffect, useState} from 'react';

import { Box, Chip, Divider, Stack, Typography } from '@mui/material';
import { Link, useParams } from 'react-router-dom';
import { LinkedinIcon, LinkedinShareButton } from 'react-share';

import { useAuth } from 'lib/auth';
import { paths } from 'routes';
import { DELEGON_URL } from 'configuration';

import { BreadCrumbs } from 'components/Breadcrumbs';
import { AccordionButton } from 'components/Button';
import { ContentLayout } from 'components/Layout';

import { useBlogByID } from '../api/getByID';
import { useTrackVisit } from 'hook/useTrackVisit';
import { isoToDateString } from 'utils/dateFormatter';
// import { ProfileImage } from '../components/ProfileImage';
// import { EditUser } from '../components/EditUserModal';
import { BlogPicture } from '../components/BlogPicture';
import { Loader } from 'components/Loader';
import { Switch } from 'components/Switch';
import { ImageAvatar } from 'components/Avatar';
// import { ReactComponent as LinkedinLogo } from 'assets/linkedin logo.svg';
import DelegonSmallLogo from 'assets/Delegon_Small_Logo.png';
import { Edit } from '../components/Edit';
import { StatusToggleButton } from '../components/StatusToggleButton';
import { RecentBlogPosts } from '../components/RecentBlogPosts';
import { CompanyProfile } from 'components/CompanyProfile/CompanyProfile';

const UserDetail = ({ label, value, linkTo = '' }) => (
  <Stack gap={1}>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
    <Typography
      variant="body2"
      color="text.primary"
      component={linkTo ? Link : 'div'}
      {...(linkTo && { to: linkTo })}
    >
      {value || ''}
    </Typography>
  </Stack>
);

export const DetailsView = () => {
  const { account, user: requester } = useAuth();
  let { id } = useParams();
  const [ loading, setLoading ] = useState(false);
  const [timer, setTimer] = useState(null);

  const { data: blog, refetch, isLoading, isFetched, isError, error } = useBlogByID(id);
  useTrackVisit('blog', blog?.blog_id, 'app');

  if(loading && !isLoading) {
    setLoading(false);
  }

  useEffect(() => {  
    if (isLoading) {
      const timeoutId = setTimeout(() => setLoading(true), 500);
      setTimer(timeoutId);
    } else {
      clearTimeout(timer);
    }

    return () => clearTimeout(timer);
  }, [isLoading]);

  if (isFetched) {    
    if (loading) {      
      setTimeout(() => setLoading(false), 1000);
    }
  }
  
  
  if (!loading && isError) {
    const err = JSON.parse(error?.response?.data?.error)
    return <div>{err.error}</div>;
  }

  return (
    <ContentLayout>
      {isLoading && !loading ? (
        <></>
      )
      : (
        loading ? (
          <Loader style={{marginTop: "40vh"}}/>
        )
        : (
          <Stack width={1} height={1}>
            <Box height={40} />
            <Stack height={1} width={1} alignItems={"center"} bgcolor={"background.paper"}>
              <Stack height={1} maxWidth={832} justifySelf={"center"} px={2} py={2} boxSizing={"border-box"} width={1}>
                <Stack>
                  {/* <BreadCrumbs
                    items={[
                      { name: '', to: paths.blogs },
                      {
                        name: 'Blogs',
                        to: paths.blogs,
                      },
                      { name: `${blog?.title}` },
                    ]}
                  /> */}
                  {loading && (
                    <Loader style={{marginTop: "40vh"}} />
                  )}

                  {!loading && (
                    <>
                    <Stack position="relative" flexDirection="column" gap={4}>
                      <Stack gap={1}>
                        <Stack flexDirection={"row"} justifyContent={"space-between"}>
                          <Chip
                            label={blog?.tag || ''}
                            sx={{
                              fontSize: "0.75rem",
                              fontWeight: 500,
                              lineHeight: "20px",
                              color: "#fff",
                              backgroundColor: "primary.light",
                              borderRadius: "6px",
                              width: "fit-content",
                            }}
                          />
                          {(account.super_admin || (requester.Company?.Type === 'buyer' && requester.Company?.company_id === blog?.creator_id)) && (
                            <AccordionButton label="Actions" sx={{ width: 130 }} top={0} boxSX={{right: 0}}>
                              <Stack gap={0.5}>
                                {<Edit blog={blog} refetch={refetch} />}
                                {account.super_admin && (
                                  <StatusToggleButton
                                    refetch={refetch}
                                    status={blog?.Status}
                                  />
                                )}
                              </Stack>
                            </AccordionButton>
                          )}
                        </Stack>
                        <Typography variant="h3" sx={{fontSize: "2.5rem", fontWeight: 600, lineHeight: 1.45, letterSpacing: 0, wordWrap: 'break-word' }}>
                          {blog?.title || ''}
                        </Typography>

                        <Stack flexDirection={"row"} sx={{alignItems: "center", justifyContent: "space-between"}} gap={1} width={1}>
                          <Stack flexDirection={"row"} sx={{alignItems: "center"}} gap={1}>
                            <ImageAvatar
                              img={(blog?.Creator && blog?.Creator?.company_id !== 0) ? blog?.Creator?.square_logo_url : DelegonSmallLogo || ''}
                              name={(blog?.Creator && blog?.Creator?.company_id !== 0) ? blog?.Creator?.Name : "Delegon"}
                              sx={{
                                backgroundColor: "#fff",
                                width: 25,
                                height: 25,
                                img : {
                                  width: 25,
                                  height: 25,
                                  overflow: 'hidden',
                                },
                              }}
                            />
                            <Stack flexDirection={"column"}>
                              <Typography variant="body3" sx={{fontFeatureSettings: `'liga' off, 'vlig' off`, fontSize: "0.625rem", fontWeight: 400, lineHeight: "normal"}}>
                                {(blog?.Creator && blog?.Creator?.company_id !== 0) ? blog?.Creator?.Name : "Delegon"}
                              </Typography>
                              <Typography variant="body3" sx={{fontSize: "0.625rem", fontWeight: 400, lineHeight: "normal"}}>
                                {isoToDateString(blog?.created_on, false)}
                              </Typography>
                            </Stack>
                          </Stack>
                          <Box sx={{height: 24, width: 24, display: "flex", alignItems: "center", justifyContent: "center", pt: 0.5, boxSizing: "border-box"}}>
                            <LinkedinShareButton url={`${DELEGON_URL}${paths.public.blogDetailsView(blog?.slug)}`}>
                              <LinkedinIcon size={24} borderRadius={16} />
                            </LinkedinShareButton>
                          </Box>
                        </Stack>
                      </Stack>

                      <BlogPicture picture={blog?.picture_url} />

                      <Typography variant='body2' sx={{fontSize: "1rem", fontWeight: 400, lineHeight: 1.75, whiteSpace: 'pre-wrap', wordWrap: 'break-word'}}>
                        {blog?.content}
                      </Typography>
                  </Stack>
                  <CompanyProfile company_name={blog?.Creator?.Name} square_logo_url={blog?.Creator?.square_logo_url} banner_logo_url={blog?.Creator?.background_image_url} description={blog?.Creator?.CompanyProfile?.about_us} slug={blog?.Creator?.CompanyProfile?.slug} company_id={blog?.Creator?.company_id} sx={{mt: 8}} />
                  <RecentBlogPosts currentPostID={id} />
                  </>
                  )}
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        )
      )}
    </ContentLayout>
  );
};
